/* Waxit collection sidebar filters. Desktop: ticking applies straight away. Mobile: bottom sheet, applies on Show results.
   Results swap in place through the Section Rendering API (?section_id=), URL updates, Back reloads that state.
   Without JS (or if a fetch fails) the form and links behave as normal page loads.
   While the mobile sheet is open, body gets .wxc-sheet-open (wx-collection-side.css hides the chat/rewards launchers so they don't cover Show results). */
(function () {
  var desk = window.matchMedia('(min-width: 990px)');
  var KEY = 'wxc-closed';
  var pushed = false;
  var closeCurrent = null;
  /* One Escape handler for the page (filter re-renders used to add another each time). */
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && closeCurrent) closeCurrent(); });
  function closedSet() { try { return JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function saveClosed(list) { try { sessionStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function unlock() { document.body.style.overflow = ''; document.body.classList.remove('wxc-sheet-open'); }

  function init(root) {
    (root || document).querySelectorAll('[data-wxc-side]').forEach(function (form) {
      if (form.dataset.bound) return; form.dataset.bound = '1';
      var sec = form.closest('.wxc-grid'), wrap = sec && sec.closest('[id^="shopify-section-"]');
      var sheet = form.querySelector('[data-wxc-sheet]');
      var closed = closedSet();
      form.querySelectorAll('details[data-wxc-fs]').forEach(function (d) {
        if (closed.indexOf(d.dataset.wxcFs) > -1 && !d.querySelector('input:checked')) d.open = false;
        d.addEventListener('toggle', function () {
          var list = closedSet().filter(function (k) { return k !== d.dataset.wxcFs; });
          if (!d.open) list.push(d.dataset.wxcFs);
          saveClosed(list);
        });
      });

      function open() { sheet.hidden = false; document.body.style.overflow = 'hidden'; document.body.classList.add('wxc-sheet-open'); }
      function close() { if (!desk.matches) sheet.hidden = true; unlock(); }
      /* Only the toolbar Filter button opens the sheet. Product cards reuse data-wxc-open for their own
         size picker, so those are skipped (they used to open the sheet and lock page scrolling too). */
      sec.querySelectorAll('[data-wxc-open]').forEach(function (b) { if (!b.closest('.wxh-card, .wxc-pick')) b.addEventListener('click', open); });
      form.querySelectorAll('[data-wxc-close]').forEach(function (b) { b.addEventListener('click', close); });
      closeCurrent = function () { if (!desk.matches && !sheet.hidden) close(); };

      /* Keeps any query already on the form action, e.g. ?q=CARPRO on /collections/vendors and /collections/types
         (it used to produce ?q=CARPRO?sort_by=..., a 404). Filter, sort and page params are replaced, not doubled. */
      function url() {
        var action = form.getAttribute('action') || window.location.pathname;
        var base = action.split('?')[0], p = new URLSearchParams(action.split('?')[1] || '');
        Array.from(p.keys()).forEach(function (k) { if (/^filter\.|^sort_by$|^page$/.test(k)) p.delete(k); });
        new FormData(form).forEach(function (v, k) { if (v !== '' && k !== 'q') p.append(k, v); });
        var q = p.toString();
        return base + (q ? '?' + q : '');
      }
      function go(href) {
        if (!wrap || !window.fetch || !window.DOMParser) { window.location.href = href; return; }
        var sid = wrap.id.replace('shopify-section-', '');
        sec.classList.add('is-loading');
        fetch(href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.wxc-grid');
            if (!fresh) throw new Error('no grid');
            var n = document.importNode(fresh, true);
            sec.replaceWith(n);
            unlock();
            history.pushState({ wxc: 1 }, '', href); pushed = true;
            n.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: sid } }));
            if (window.okeWidgetApi && window.okeWidgetApi.initAllWidgets) window.okeWidgetApi.initAllWidgets();
            document.dispatchEvent(new CustomEvent('wx:variant'));
            var top = n.getBoundingClientRect().top;
            if (top < 0) window.scrollTo({ top: window.scrollY + top - 16, behavior: 'smooth' });
          })
          .catch(function () { window.location.href = href; });
      }
      var t;
      function apply(delay) { clearTimeout(t); t = setTimeout(function () { go(url()); }, delay || 0); }

      form.addEventListener('change', function (e) {
        if (!desk.matches) return;
        apply(e.target.type === 'range' ? 250 : e.target.type === 'number' ? 400 : 0);
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); close(); go(url()); });
      var sort = sec.querySelector('[data-wxc-sort]');
      if (sort) sort.addEventListener('change', function () { apply(0); });
      sec.addEventListener('click', function (e) {
        var a = e.target.closest('a[data-wxc-nav]');
        if (a) { e.preventDefault(); close(); go(a.getAttribute('href')); return; }
        var sa = e.target.closest('[data-wxc-showall]');
        if (sa) { sa.closest('.wxc-fs__body').querySelectorAll('.wxc-opt.is-extra').forEach(function (x) { x.classList.remove('is-extra'); }); sa.remove(); }
      });
    });
  }
  window.addEventListener('popstate', function () { if (pushed) window.location.reload(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
